var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39028 0.238534C1.07223 -0.0795112 0.556578 -0.0795112 0.238534 0.238534C-0.0795112 0.556578 -0.0795112 1.07223 0.238534 1.39028L7.80671 8.95845L0.238535 16.5266C-0.0795095 16.8447 -0.0795095 17.3603 0.238535 17.6784C0.55658 17.9964 1.07223 17.9964 1.39028 17.6784L8.95845 10.1102L16.5266 17.6784C16.8447 17.9964 17.3603 17.9964 17.6784 17.6784C17.9964 17.3603 17.9964 16.8447 17.6784 16.5266L10.1102 8.95845L17.6784 1.39028C17.9964 1.07223 17.9964 0.556578 17.6784 0.238534C17.3603 -0.0795112 16.8447 -0.0795112 16.5266 0.238534L8.95845 7.80671L1.39028 0.238534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.f592583e96bde5340633e6dd090560d2.svg";
export { ForwardRef as ReactComponent };